import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import { Icon, useOccAssets, useOccContext } from '@vista-digital/occ-ui'
import type { FC } from 'react'

export interface CarouselScrollButtonProps {
    enabled: boolean
    direction: 'Previous' | 'Next'
    onClick: VoidFunction
}

const b = bemClassBuilder('v-carousel-scroll-button')

export const CarouselScrollButton: FC<CarouselScrollButtonProps> = props => {
    const { enabled, direction, onClick } = props
    const { carouselPreviousButtonIconName, carouselNextButtonIconName } = useOccAssets()
    const { carouselPreviousButtonAriaLabel, carouselNextButtonAriaLabel } = useOccContext().accessibilityText
    const isPreviousButton = direction === 'Previous'
    const iconName = isPreviousButton ? carouselPreviousButtonIconName : carouselNextButtonIconName
    const ariaLabel = isPreviousButton ? carouselPreviousButtonAriaLabel : carouselNextButtonAriaLabel

    return (
        <button
            className={b.block({ [direction]: true, disabled: !enabled })}
            onClick={onClick}
            disabled={!enabled}
            aria-label={ariaLabel}
        >
            <Icon name={iconName} />
        </button>
    )
}

CarouselScrollButton.displayName = 'CarouselScrollButton'
